// THIS FILE IS GENERATED by packages/console-api-types/scripts/gen-operations.ts. Do not edit.
// Run `npm run generate -w @akashnetwork/console-api-types` to regenerate.

export const operations = {
  v1: {
    listStripePrices: { path: "/v1/stripe/prices", method: "get", operationId: "listStripePrices", pathParams: [], queryParams: [], hasBody: false },
    applyStripeCoupon: { path: "/v1/stripe/coupons/apply", method: "post", operationId: "applyStripeCoupon", pathParams: [], queryParams: [], hasBody: true },
    updateStripeCustomerOrganization: {
      path: "/v1/stripe/customers/organization",
      method: "put",
      operationId: "updateStripeCustomerOrganization",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    createSetupIntent: {
      path: "/v1/stripe/payment-methods/setup",
      method: "post",
      operationId: "createSetupIntent",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    setDefaultPaymentMethod: {
      path: "/v1/stripe/payment-methods/default",
      method: "post",
      operationId: "setDefaultPaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    getDefaultPaymentMethod: {
      path: "/v1/stripe/payment-methods/default",
      method: "get",
      operationId: "getDefaultPaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    listPaymentMethods: {
      path: "/v1/stripe/payment-methods",
      method: "get",
      operationId: "listPaymentMethods",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    deletePaymentMethod: {
      path: "/v1/stripe/payment-methods/{paymentMethodId}",
      method: "delete",
      operationId: "deletePaymentMethod",
      pathParams: ["paymentMethodId"],
      queryParams: [],
      hasBody: false
    },
    validatePaymentMethod: {
      path: "/v1/stripe/payment-methods/validate",
      method: "post",
      operationId: "validatePaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    confirmStripeTransaction: {
      path: "/v1/stripe/transactions/confirm",
      method: "post",
      operationId: "confirmStripeTransaction",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listStripeTransactions: {
      path: "/v1/stripe/transactions",
      method: "get",
      operationId: "listStripeTransactions",
      pathParams: [],
      queryParams: ["limit", "startingAfter", "endingBefore", "startDate", "endDate"],
      hasBody: false
    },
    exportStripeTransactions: {
      path: "/v1/stripe/transactions/export",
      method: "get",
      operationId: "exportStripeTransactions",
      pathParams: [],
      queryParams: ["timezone", "startDate", "endDate"],
      hasBody: false
    },
    getDeployment: { path: "/v1/deployments/{dseq}", method: "get", operationId: "getDeployment", pathParams: ["dseq"], queryParams: [], hasBody: false },
    closeDeployment: {
      path: "/v1/deployments/{dseq}",
      method: "delete",
      operationId: "closeDeployment",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: false
    },
    updateDeployment: { path: "/v1/deployments/{dseq}", method: "put", operationId: "updateDeployment", pathParams: ["dseq"], queryParams: [], hasBody: true },
    createDeployment: { path: "/v1/deployments", method: "post", operationId: "createDeployment", pathParams: [], queryParams: [], hasBody: true },
    listDeployments: { path: "/v1/deployments", method: "get", operationId: "listDeployments", pathParams: [], queryParams: ["skip", "limit"], hasBody: false },
    depositDeployment: { path: "/v1/deposit-deployment", method: "post", operationId: "depositDeployment", pathParams: [], queryParams: [], hasBody: true },
    createLease: { path: "/v1/leases", method: "post", operationId: "createLease", pathParams: [], queryParams: [], hasBody: true },
    listApiKeys: { path: "/v1/api-keys", method: "get", operationId: "listApiKeys", pathParams: [], queryParams: [], hasBody: false },
    listBids: { path: "/v1/bids", method: "get", operationId: "listBids", pathParams: [], queryParams: ["dseq"], hasBody: false },
    listGpuPrices: { path: "/v1/gpu-prices", method: "get", operationId: "listGpuPrices", pathParams: [], queryParams: [], hasBody: false },
    screenProviders: { path: "/v1/bid-screening", method: "post", operationId: "screenProviders", pathParams: [], queryParams: [], hasBody: true },
    createAlert: { path: "/v1/alerts", method: "post", operationId: "createAlert", pathParams: [], queryParams: [], hasBody: true },
    listAlerts: {
      path: "/v1/alerts",
      method: "get",
      operationId: "listAlerts",
      pathParams: [],
      queryParams: ["limit", "page", "type", "dseq"],
      hasBody: false
    },
    getAlert: { path: "/v1/alerts/{id}", method: "get", operationId: "getAlert", pathParams: ["id"], queryParams: [], hasBody: false },
    updateAlert: { path: "/v1/alerts/{id}", method: "patch", operationId: "updateAlert", pathParams: ["id"], queryParams: [], hasBody: true },
    deleteAlert: { path: "/v1/alerts/{id}", method: "delete", operationId: "deleteAlert", pathParams: ["id"], queryParams: [], hasBody: false },
    createNotificationChannel: {
      path: "/v1/notification-channels",
      method: "post",
      operationId: "createNotificationChannel",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listNotificationChannels: {
      path: "/v1/notification-channels",
      method: "get",
      operationId: "listNotificationChannels",
      pathParams: [],
      queryParams: ["limit", "page"],
      hasBody: false
    },
    createDefaultNotificationChannel: {
      path: "/v1/notification-channels/default",
      method: "post",
      operationId: "createDefaultNotificationChannel",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    getNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "get",
      operationId: "getNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    updateNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "patch",
      operationId: "updateNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "delete",
      operationId: "deleteNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    upsertDeploymentAlert: {
      path: "/v1/deployment-alerts/{dseq}",
      method: "post",
      operationId: "upsertDeploymentAlert",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: true
    },
    listDeploymentAlerts: {
      path: "/v1/deployment-alerts/{dseq}",
      method: "get",
      operationId: "listDeploymentAlerts",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: false
    }
  }
} as const;

export type Operations = typeof operations;
